module.exports = __webpack_public_path__ + "img/p8-1.96e87a5e.png";